import { render, staticRenderFns } from "./test.vue?vue&type=template&id=207af43e&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/test.scss?vue&type=style&index=0&id=207af43e&lang=scss&scoped=true&"
import style1 from "./test.vue?vue&type=style&index=1&id=207af43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207af43e",
  null
  
)

export default component.exports